import ReactDOM from 'react-dom/client';
import App from './App.tsx';

// Configure onnxruntime-web WASM paths before any initialization
// This must be done before any onnxruntime-web modules are imported
import * as ort from 'onnxruntime-web/all';
import { restoreConfigFromStorage } from './Utils/ConfigPersistence';

// Set WASM files to use default path resolution
ort.env.wasm.wasmPaths = '';
ort.env.wasm.proxy = true;

console.log('WASM paths configured for default resolution:', ort.env.wasm.wasmPaths);

// Capture/restore the ?c= config blob before anything reads the URL, so the
// config survives PWA home-screen launches (manifest start_url strips ?c=).
restoreConfigFromStorage();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);

// Register the minimal service worker so Chrome/Android will offer to install
// the app as a PWA (an installable PWA requires a registered SW with a fetch
// handler; see public/sw.js). Uses a base-relative path so it works whether the
// app is served from the origin root or a sub-path. Failures are non-fatal:
// unsupported browsers or insecure (non-HTTPS) origins just skip installation.
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js').catch((err) => {
            console.warn('Service worker registration failed:', err);
        });
    });
}
